// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import "../Admin-Reporting/AdminReporting.css"
// import reportIcon from "../../assets/images/download-report.png";
// import { jwtDecode } from "jwt-decode";
// const AdminAllReports = () => {
//   const navigate = useNavigate();
//   const [startDate, setStartDate] = useState(getFormattedDate(7));
//   const [endDate, setEndDate] = useState(getFormattedDate(1));
//   const [dateRange, setDateRange] = useState("last7");

//   const [reportData, setReportData] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [isDisabled, setIsDisabled] = useState(false);

//   const [searchPubName, setSearchPubName] = useState("");
//   const [searchDomain, setSearchDomain] = useState("");
//   const [searchAdunitName, setSearchAdunitName] = useState("");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalEntries, setTotalEntries] = useState(0);
//   const entriesPerPage = 50;


//   // date login
//   // function getFormattedDate(daysAgo = 0) {
//   //   const date = new Date();
//   //   date.setDate(date.getDate() - daysAgo);
//   //   return date.toISOString().split("T")[0];
//   // }

//   function formatLocalDate(date) {
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");

//   return `${year}-${month}-${day}`;
// }

// function getFormattedDate(daysAgo = 0) {
//   const date = new Date();
//   date.setDate(date.getDate() - daysAgo);

//   return formatLocalDate(date);
// }

//   //date range handler
//   const handleDateRangeChange = (e) => {
//   const selectedRange = e.target.value;

//   setDateRange(selectedRange);
//   setErrorMessage("");
//   setIsDisabled(false);

//   switch (selectedRange) {
//     // case "today":
//     //   setStartDate(getFormattedDate(0));
//     //   setEndDate(getFormattedDate(0));
//     //   break;

//     case "yesterday":
//       setStartDate(getFormattedDate(1));
//       setEndDate(getFormattedDate(1));
//       break;

//     case "last7":
//       // 7 completed days, excluding today
//       setStartDate(getFormattedDate(7));
//       setEndDate(getFormattedDate(1));
//       break;

//     case "last15":
//       // 15 completed days, excluding today
//       setStartDate(getFormattedDate(15));
//       setEndDate(getFormattedDate(1));
//       break;

//     case "last30":
//       // 30 completed days, excluding today
//       setStartDate(getFormattedDate(30));
//       setEndDate(getFormattedDate(1));
//       break;
    
//     case "thisMonth" : {
//       const today = new Date();
//       const year = today.getFullYear();
//       const month = String(today.getMonth() + 1).padStart(2, "0");
//       const firstDayOfMonth  = new Date(
//         today.getFullYear(),
//         today.getMonth(),
//         1
//       );
//       // const startDate = `${year}-${month}-01`;
//       // setStartDate(startDate);
//       setStartDate(formatLocalDate(firstDayOfMonth));
//       setEndDate(getFormattedDate(1)); // yesterday
//       break;
//     }
//     case "lastMonth": {
//     const today = new Date();

//     const firstDayLastMonth = new Date(
//       today.getFullYear(),
//       today.getMonth() - 1,
//       1
//     );

//     const lastDayLastMonth = new Date(
//       today.getFullYear(),
//       today.getMonth(),
//       0
//     );

//     // const formatLocalDate = (date) => {
//     //   const year = date.getFullYear();
//     //   const month = String(date.getMonth() + 1).padStart(2, "0");
//     //   const day = String(date.getDate()).padStart(2, "0");

//     //   return `${year}-${month}-${day}`;
//     // };

//     setStartDate(formatLocalDate(firstDayLastMonth));
//     setEndDate(formatLocalDate(lastDayLastMonth));

//     break;
//   }
//     case "custom":
//       // Don't change dates
//       break;

//     default:
//       break;
//   }
// };

//   function formatDateToYYYYMMDD(date) {
//     // return new Date(date).toISOString().split("T")[0];
//     // return formatLocalDate(new Date(date + "T00:00:00"));
//     return date;
//   }

//   function validateDateRange(start, end) {
//     const startDateObj = new Date(start);
//     const endDateObj = new Date(end);
//     const today = new Date();

//     if (startDateObj > today) {
//       setErrorMessage("Start Date cannot exceed today's date!");
//       return true;
//     }
//     if (endDateObj > today) {
//       setErrorMessage("End Date cannot exceed today's date!");
//       return true;
//     }
//     if (endDateObj < startDateObj) {
//       setErrorMessage("End Date cannot be before Start Date!");
//       return true;
//     }

//     const diffInDays = (endDateObj - startDateObj) / (1000 * 60 * 60 * 24);
//     if (diffInDays > 90) {
//       setErrorMessage("Date range cannot exceed 3 months!");
//       return true;
//     }

//     setErrorMessage("");
//     return false;
//   }
//   // Event Handlers
//   const handleStartDateChange = (e) => {
//     const newStartDate = formatDateToYYYYMMDD(e.target.value);

//     setStartDate(newStartDate);
//     setDateRange("custom");

//     const hasError = validateDateRange(newStartDate, endDate);
//     setIsDisabled(hasError);
//   };

//   const handleEndDateChange = (e) => {
//     const newEndDate = formatDateToYYYYMMDD(e.target.value);

//     setEndDate(newEndDate);
//     setDateRange("custom");

//     const hasError = validateDateRange(startDate, newEndDate);
//     setIsDisabled(hasError);
//   };

//   const fetchReportData = async (page = 1) => {
//     try {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         console.error("No token found!");
//         return;
//       }
//       const { role } = jwtDecode(token);
      
//       const endPoint = (role === "ad_ops" || role === "account_manager") ? "detailedDataReport" : "detailedReport";
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/admin/${endPoint}?page=${page}`,
//         { startDate, 
//           endDate,
//           search_pub_name: searchPubName,
//           search_domain: searchDomain,
//           search_adunit_name: searchAdunitName,
//          },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//         }
//       );
      
//       const data = response?.data?.data;
//       setReportData(data.data || []);
//       setTotalEntries(data.total || 0);
//     } catch (error) {
//       if (error.response?.status === 401) {
//         localStorage.removeItem("token");
//         navigate("/");
//       } else {
//         console.error("Error fetching data:", error);
//       }
//     }
//   };
// // download report logic
// const downloadReport = async () => {
//   const token = localStorage.getItem("token");
//   const { role } = jwtDecode(token);
//     if (!token) {
//       alert("No token found!");
//       return;
//     }
//   try {
//     const pageSize = entriesPerPage;
//     let page = 1;
//     let allData = [];
//     let totalPages = 1;
//     const endPoint = ( role === "ad_ops" || role === "account_manager" ) ? "detailedDataReport" : "detailedReport";
//     do {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/api/admin/${endPoint}?page=${page}`,
//         { startDate, 
//           endDate,           
//           search_pub_name: searchPubName,
//           search_domain: searchDomain,
//           search_adunit_name: searchAdunitName,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: "application/json",
//           },
//         }
//       );

//       const responseData = response?.data?.data;
//       const pageData = responseData?.data || [];
//       allData = [...allData, ...pageData];

//       if (page === 1) {
//         const total = responseData?.total || 0;
//         totalPages = Math.ceil(total / pageSize);
//       }

//       page++;
//     } while (page <= totalPages);

//     if (allData.length === 0) {
//       alert("No data available to download!");
//       return;
//     }

//     const filteredData = allData.map(
//       ({ date, domain, account_name, ad_id, clicks, impressions, ctr, ecpm, fill_rate, m_ad_display_name, m_ad_unit_name, pubRev, pub_eCPM, revenue, viewable_impression, requests, match_requests, coverage, orig_impressions, orig_pubRev, orig_requests, p_isvisible, m_isvisible}) => ({
//         Date: date,
//         Domain: domain,
//         Account_Name: account_name,
//         m_ad_display_name: m_ad_display_name,
//         m_ad_unit_name: m_ad_unit_name,
//         ad_id: ad_id,
//         requests:requests,
//         match_requests:match_requests,
//         coverage:coverage,
//         impressions: impressions,
//         fill_rate: fill_rate,
//         clicks: clicks,
//         ctr: (ctr === null ? "0" : ctr),
//         viewable_impression: (viewable_impression === null ? "0" : viewable_impression),
//         pubRev: pubRev,
//         pub_eCPM: (pub_eCPM === null ? "0" : pub_eCPM),
//         revenue:revenue,
//         ecpm: (ecpm === null ? "0" : ecpm),
//         orig_requests:orig_requests,
//         orig_impressions:(orig_impressions === null ? "0" : orig_impressions),
//         // orig_pubRev:Number(orig_pubRev.toFixed(2)),
//         orig_pubRev:orig_pubRev,
//         isvisible:(p_isvisible === 1 ? "No" : "Yes"),
//         multi_tag_isvisible:(m_isvisible === 1 ? "No" : "Yes")

//       })
//     );

//     const worksheet = XLSX.utils.json_to_sheet(filteredData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//     const fileName = `Report_${startDate}_to_${endDate}.xlsx`;
//     XLSX.writeFile(workbook, fileName);
//   } catch (error) {
//     if (error.response?.status === 401) {
//       localStorage.removeItem("token");
//       navigate("/");
//     } else {
//       console.error("Download error:", error);
//       alert("Failed to download report.");
//     }
//   }
// };  
//   useEffect(() => {
//     fetchReportData(currentPage);
//   }, [currentPage]);

//   // Pagination logic
//   const indexOfLastEntry = currentPage * entriesPerPage;
//   const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
//   const currentEntries = reportData.slice(indexOfFirstEntry, indexOfLastEntry);
//   const totalPages = Math.ceil(totalEntries / entriesPerPage);  
//  return (
//     <section className="mainContainer">
//       <div className="adminReportDate">
//         <form
//           onSubmit={(e) => {
//             e.preventDefault();
//             fetchReportData(1);
//             setCurrentPage(1);
//           }}
//         >
//           <div className="row">
//             <h4 className="section-title">Report Filters</h4>
//           <div className="col-4">
//               <input
//                 type="text"
//                 className="form-control"
//                 id="pubName"
//                 value={searchPubName}
//                 placeholder="Search Pub Name"
//                 onChange={(e) => setSearchPubName(e.target.value)}
//               />
//             </div>
//             <div className="col-4">
//               <input
//                 type="text"
//                 className="form-control"
//                 id="domain"
//                 value={searchDomain}
//                 placeholder="Search Domain"
//                 onChange={(e) => setSearchDomain(e.target.value)}
//               />
//             </div>
//             <div className="col-4">
//               {/* <label htmlFor="startDate">Start Date</label> */}
//               <input
//                 type="text"
//                 className="form-control"
//                 id="adunitName"
//                 value={searchAdunitName}
//                 placeholder="Search Adunit Name"
//                 onChange={(e) => setSearchAdunitName(e.target.value)}
//               />
//             </div>
//           </div>
//           {/* <div className="reportingDate mb-3 mt-3">
//             <div className="col-5 mx-3">
//               <label htmlFor="startDate">Start Date</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 id="startDate"
//                 value={startDate}
//                 onChange={handleStartDateChange}
//               />
//             </div>
//             <div className="col-5">
//               <label htmlFor="endDate">End Date</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 id="endDate"
//                 value={endDate}
//                 onChange={handleEndDateChange}
//               />
//             </div>
//             <div className="col-2 mx-3 mt-4">
//               <button type="submit" className="btn btn-primary" disabled={isDisabled}>
//                 Submit
//               </button>
//             </div>
//           </div> */}
//         <div className="reportingDate mb-3 mt-3 row">

//           {/* Date Range Dropdown */}
//           <div className="col-4 mx-3">
//             {/* <label htmlFor="dateRange">Date Range</label> */}
//             <select id="dateRange" className="form-control" value={dateRange} onChange={handleDateRangeChange}>
//               {/* <option value="today">Today</option> */}
//               <option value="yesterday">Yesterday</option>
//               <option value="last7">Last 7 Days</option>
//               <option value="last15">Last 15 Days</option>
//               <option value="last30">Last 30 Days</option>
//               <option value="thisMonth">This Month</option>
//               <option value="lastMonth">Last Month</option>
//               <option value="custom">Custom Range</option>
//             </select>
//           </div>

//           {/* Show dates ONLY for Custom Range */}
//           {dateRange === "custom" && (
//             <>
//               {/* Start Date */}
//               <div className="col-3">
//                 <label htmlFor="startDate">Start Date</label>
//                 <input type="date" className="form-control" id="startDate" value={startDate} onChange={handleStartDateChange} />
//               </div>

//               {/* End Date */}
//               <div className="col-3">
//                 <label htmlFor="endDate">End Date</label>
//                 <input type="date" className="form-control" id="endDate" value={endDate} onChange={handleEndDateChange} />
//               </div>
//             </>
//           )}

//           {/* Submit */}
//           <div className="col-4">
//             <button type="submit" className="publisher-submit-btn" disabled={isDisabled}>
//               Submit
//             </button>
//           </div>

//         </div>
//         {errorMessage && (
//           <p style={{ color: "red" }} className="mx-4 my-0">
//             {errorMessage}
//           </p>
//         )}
//         </form>
//      </div>
//      <div className="mb-3 mx-3 d-flex justify-content-end">
//        <button className="btn btn-success downlodeBtn" onClick={downloadReport}>
//          Download <img src={reportIcon} alt="Download" />
//        </button>
//      </div>
//      <div className="report-table-wrapper">
//        <div className="table-responsive adminReport">
//          <table className="table table-striped table-hover table-bordered report-table">
//            <thead>
//              <tr>
//                <th>SN</th>
//                <th>Date</th>
//                <th>Domain</th>
//                <th>Account Name</th>
//                <th>Ad Id</th>
//                <th>Clicks</th>
//                <th>Impressions</th>
//                <th>CTR</th>
//                <th>Fill Rate</th>
//                {/* <th>m_ad_display_name </th> */}
//                <th>Ad Display Name </th>
//                <th>Ad Unit Name</th>
//                <th>Pub Revenue</th>
//                <th>Pub eCPM</th>
//                <th>Revenue</th>
//                <th>eCPM</th>
//                <th>Viewable Impression</th>
//                <th>Requests</th>
//                <th>Match Requests</th>
//                <th>Coverage</th>
//                <th>Original Impressions</th>
//                <th>Original PubRev</th>
//                <th>Original Requests</th>
//                <th>Visible on Report</th>
//                <th>Multi Tag Visible on Report</th>
//              </tr>
//            </thead>
//            <tbody>
//              {reportData.length > 0 ? (
//                reportData.map((entry, index) => (
//                  <tr key={index}>
//                    <td>{index + 1}</td>
//                    <td>{entry.date}</td>
//                    <td>{entry.domain}</td>
//                    <td>{entry.account_name}</td>
//                    <td>{entry.ad_id}</td>
//                    <td>{entry.clicks}</td>
//                    <td>{entry.impressions}</td>
//                    <td>{entry.ctr === null ? "0" : entry.ctr}</td>
//                    <td>{entry.fill_rate}</td>
//                    <td>{entry.m_ad_display_name}</td>
//                    <td>{entry.m_ad_unit_name}</td>
//                    <td>{entry.pubRev}</td>
//                    <td>{entry.pub_eCPM === null ? "0" : entry.pub_eCPM}</td>
//                    <td>{entry.revenue}</td>
//                    <td>{entry.ecpm === null ? "0" : entry.ecpm}</td>
//                    <td>{entry.viewable_impression}</td>
//                    <td>{entry.requests}</td>
//                    <td>{entry.match_requests}</td>
//                    <td>{entry.coverage}</td>
//                    <td>{entry.orig_impressions}</td>
//                    <td>{entry.orig_pubRev}</td>
//                    <td>{entry.orig_requests}</td>
//                    <td>{entry?.p_isvisible === 1 ? "No" : "Yes"}</td>
//                    <td>{entry?.m_isvisible === 1 ? "No" : "Yes"}</td>
//                  </tr>
//                ))
//              ) : (
//                <tr>
//                  <td colSpan={24} className="text-center">No data available</td>
//                </tr>
//              )}
//            </tbody>
//          </table>
//        </div>
//      </div>
//       {
//           totalEntries > 50 ?       
//           <div className="pagination d-flex justify-content-center mt-3">
//           {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
//             <button
//               key={number}
//               onClick={() => setCurrentPage(number)}
//               className={`btn mx-1 ${currentPage === number ? "btn-primary" : "btn-outline-primary"}`}
//             >
//               {number}
//             </button>
//           ))}
//         </div> : null
//         }
//     </section>

//  );
// };

// export default AdminAllReports;

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import "../Admin-Reporting/AdminReporting.css"
import reportIcon from "../../assets/images/download-report.png";
import { jwtDecode } from "jwt-decode";
// Totals are calculated for the rows in the current API page (50 per page).
// The API must return separate aggregates to show grand totals for all filtered records.
const SUM_FIELDS = [
  "clicks",
  "impressions",
  "pubRev",
  "revenue",
  "viewable_impression",
  "requests",
  "match_requests",
  "orig_impressions",
  "orig_pubRev",
  "orig_requests",
];

const asNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const number = Number(String(value).replace(/[,₹$%\s]/g, ""));
  return Number.isFinite(number) ? number : 0;
};

const formatCount = (value) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(value);

const formatAmount = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

const formatPercent = (numerator, denominator) =>
  denominator > 0 ? `${((numerator / denominator) * 100).toFixed(2)}%` : "0.00%";

const formatEcpm = (revenue, impressions) =>
  impressions > 0 ? formatAmount((revenue / impressions) * 1000) : "0.00";

const AdminAllReports = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(getFormattedDate(7));
  const [endDate, setEndDate] = useState(getFormattedDate(1));
  const [dateRange, setDateRange] = useState("last7");

  const [reportData, setReportData] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [searchPubName, setSearchPubName] = useState("");
  const [searchDomain, setSearchDomain] = useState("");
  const [searchAdunitName, setSearchAdunitName] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const entriesPerPage = 50;


  // date login
  // function getFormattedDate(daysAgo = 0) {
  //   const date = new Date();
  //   date.setDate(date.getDate() - daysAgo);
  //   return date.toISOString().split("T")[0];
  // }

  function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function getFormattedDate(daysAgo = 0) {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);

  return formatLocalDate(date);
}

  //date range handler
  const handleDateRangeChange = (e) => {
  const selectedRange = e.target.value;

  setDateRange(selectedRange);
  setErrorMessage("");
  setIsDisabled(false);

  switch (selectedRange) {
    // case "today":
    //   setStartDate(getFormattedDate(0));
    //   setEndDate(getFormattedDate(0));
    //   break;

    case "yesterday":
      setStartDate(getFormattedDate(1));
      setEndDate(getFormattedDate(1));
      break;

    case "last7":
      // 7 completed days, excluding today
      setStartDate(getFormattedDate(7));
      setEndDate(getFormattedDate(1));
      break;

    case "last15":
      // 15 completed days, excluding today
      setStartDate(getFormattedDate(15));
      setEndDate(getFormattedDate(1));
      break;

    case "last30":
      // 30 completed days, excluding today
      setStartDate(getFormattedDate(30));
      setEndDate(getFormattedDate(1));
      break;
    
    case "thisMonth" : {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const firstDayOfMonth  = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      // const startDate = `${year}-${month}-01`;
      // setStartDate(startDate);
      setStartDate(formatLocalDate(firstDayOfMonth));
      setEndDate(getFormattedDate(1)); // yesterday
      break;
    }
    case "lastMonth": {
    const today = new Date();

    const firstDayLastMonth = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1
    );

    const lastDayLastMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      0
    );

    // const formatLocalDate = (date) => {
    //   const year = date.getFullYear();
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const day = String(date.getDate()).padStart(2, "0");

    //   return `${year}-${month}-${day}`;
    // };

    setStartDate(formatLocalDate(firstDayLastMonth));
    setEndDate(formatLocalDate(lastDayLastMonth));

    break;
  }
    case "custom":
      // Don't change dates
      break;

    default:
      break;
  }
};

  function formatDateToYYYYMMDD(date) {
    // return new Date(date).toISOString().split("T")[0];
    // return formatLocalDate(new Date(date + "T00:00:00"));
    return date;
  }

  function validateDateRange(start, end) {
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);
    const today = new Date();

    if (startDateObj > today) {
      setErrorMessage("Start Date cannot exceed today's date!");
      return true;
    }
    if (endDateObj > today) {
      setErrorMessage("End Date cannot exceed today's date!");
      return true;
    }
    if (endDateObj < startDateObj) {
      setErrorMessage("End Date cannot be before Start Date!");
      return true;
    }

    const diffInDays = (endDateObj - startDateObj) / (1000 * 60 * 60 * 24);
    if (diffInDays > 90) {
      setErrorMessage("Date range cannot exceed 3 months!");
      return true;
    }

    setErrorMessage("");
    return false;
  }
  // Event Handlers
  const handleStartDateChange = (e) => {
    const newStartDate = formatDateToYYYYMMDD(e.target.value);

    setStartDate(newStartDate);
    setDateRange("custom");

    const hasError = validateDateRange(newStartDate, endDate);
    setIsDisabled(hasError);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = formatDateToYYYYMMDD(e.target.value);

    setEndDate(newEndDate);
    setDateRange("custom");

    const hasError = validateDateRange(startDate, newEndDate);
    setIsDisabled(hasError);
  };

  const fetchReportData = async (page = 1) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found!");
        return;
      }
      const { role } = jwtDecode(token);
      
      const endPoint = (role === "ad_ops" || role === "account_manager") ? "detailedDataReport" : "detailedReport";
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/${endPoint}?page=${page}`,
        { startDate, 
          endDate,
          search_pub_name: searchPubName,
          search_domain: searchDomain,
          search_adunit_name: searchAdunitName,
         },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      
      const data = response?.data?.data;
      setReportData(data.data || []);
      setTotalEntries(data.total || 0);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };
// download report logic
const downloadReport = async () => {
  const token = localStorage.getItem("token");
  if (!token) {
    alert("No token found!");
    return;
  }
  try {
    const { role } = jwtDecode(token);
    const pageSize = entriesPerPage;
    let page = 1;
    let allData = [];
    let totalPages = 1;
    const endPoint = ( role === "ad_ops" || role === "account_manager" ) ? "detailedDataReport" : "detailedReport";
    do {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/${endPoint}?page=${page}`,
        { startDate, 
          endDate,           
          search_pub_name: searchPubName,
          search_domain: searchDomain,
          search_adunit_name: searchAdunitName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const responseData = response?.data?.data;
      const pageData = responseData?.data || [];
      allData = [...allData, ...pageData];

      if (page === 1) {
        const total = responseData?.total || 0;
        totalPages = Math.ceil(total / pageSize);
      }

      page++;
    } while (page <= totalPages);

    if (allData.length === 0) {
      alert("No data available to download!");
      return;
    }

    const filteredData = allData.map(
      ({ date, domain, account_name, ad_id, clicks, impressions, ctr, ecpm, fill_rate, m_ad_display_name, m_ad_unit_name, pubRev, pub_eCPM, revenue, viewable_impression, requests, match_requests, coverage, orig_impressions, orig_pubRev, orig_requests, p_isvisible, m_isvisible}) => ({
        Date: date,
        Domain: domain,
        Account_Name: account_name,
        m_ad_display_name: m_ad_display_name,
        m_ad_unit_name: m_ad_unit_name,
        ad_id: ad_id,
        requests:requests,
        match_requests:match_requests,
        coverage:coverage,
        impressions: impressions,
        fill_rate: fill_rate,
        clicks: clicks,
        ctr: (ctr === null ? "0" : ctr),
        viewable_impression: (viewable_impression === null ? "0" : viewable_impression),
        pubRev: pubRev,
        pub_eCPM: (pub_eCPM === null ? "0" : pub_eCPM),
        revenue:revenue,
        ecpm: (ecpm === null ? "0" : ecpm),
        orig_requests:orig_requests,
        orig_impressions:(orig_impressions === null ? "0" : orig_impressions),
        // orig_pubRev:Number(orig_pubRev.toFixed(2)),
        orig_pubRev:orig_pubRev,
        isvisible:(p_isvisible === 1 ? "No" : "Yes"),
        multi_tag_isvisible:(m_isvisible === 1 ? "No" : "Yes")

      })
    );

    // Grand Total for ALL downloaded records across every fetched page.
    // This reuses allData and does not make any additional API requests.
    const grandTotals = allData.reduce((totals, row) => {
      SUM_FIELDS.forEach((field) => {
        totals[field] += asNumber(row[field]);
      });
      return totals;
    }, Object.fromEntries(SUM_FIELDS.map((field) => [field, 0])));

    // Use the same keys and column order as the individual Excel rows.
    const grandTotalRow = Object.fromEntries(
      Object.keys(filteredData[0]).map((key) => [key, ""])
    );

    Object.assign(grandTotalRow, {
      Date: `Grand Total (${allData.length} records)`,
      clicks: grandTotals.clicks,
      impressions: grandTotals.impressions,
      ctr: formatPercent(grandTotals.clicks, grandTotals.impressions),
      // Fill rate is intentionally blank until its API formula is confirmed.
      // Summing or averaging row-level rates would be misleading.
      fill_rate: "",
      pubRev: Number(grandTotals.pubRev.toFixed(2)),
      pub_eCPM: Number(
        (grandTotals.impressions > 0
          ? (grandTotals.pubRev / grandTotals.impressions) * 1000
          : 0).toFixed(2)
      ),
      revenue: Number(grandTotals.revenue.toFixed(2)),
      ecpm: Number(
        (grandTotals.impressions > 0
          ? (grandTotals.revenue / grandTotals.impressions) * 1000
          : 0).toFixed(2)
      ),
      viewable_impression: grandTotals.viewable_impression,
      requests: grandTotals.requests,
      match_requests: grandTotals.match_requests,
      coverage: formatPercent(grandTotals.match_requests, grandTotals.requests),
      orig_impressions: grandTotals.orig_impressions,
      orig_pubRev: Number(grandTotals.orig_pubRev.toFixed(2)),
      orig_requests: grandTotals.orig_requests,
    });

    filteredData.push(grandTotalRow);

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    const fileName = `Report_${startDate}_to_${endDate}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/");
    } else {
      console.error("Download error:", error);
      alert("Failed to download report.");
    }
  }
};  
  useEffect(() => {
    fetchReportData(currentPage);
  }, [currentPage]);

  // The response is already paginated by the server, so sum reportData directly.
  const pageTotals = useMemo(
    () =>
      reportData.reduce((totals, row) => {
        SUM_FIELDS.forEach((field) => {
          totals[field] += asNumber(row[field]);
        });
        return totals;
      }, Object.fromEntries(SUM_FIELDS.map((field) => [field, 0]))),
    [reportData]
  );

  const totalPages = Math.ceil(totalEntries / entriesPerPage);  
 return (
    <section className="mainContainer">
      <div className="adminReportDate">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            fetchReportData(1);
            setCurrentPage(1);
          }}
        >
          <div className="row">
            <h4 className="section-title">Report Filters</h4>
          <div className="col-4">
              <input
                type="text"
                className="form-control"
                id="pubName"
                value={searchPubName}
                placeholder="Search Pub Name"
                onChange={(e) => setSearchPubName(e.target.value)}
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                id="domain"
                value={searchDomain}
                placeholder="Search Domain"
                onChange={(e) => setSearchDomain(e.target.value)}
              />
            </div>
            <div className="col-4">
              {/* <label htmlFor="startDate">Start Date</label> */}
              <input
                type="text"
                className="form-control"
                id="adunitName"
                value={searchAdunitName}
                placeholder="Search Adunit Name"
                onChange={(e) => setSearchAdunitName(e.target.value)}
              />
            </div>
          </div>
          {/* <div className="reportingDate mb-3 mt-3">
            <div className="col-5 mx-3">
              <label htmlFor="startDate">Start Date</label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </div>
            <div className="col-5">
              <label htmlFor="endDate">End Date</label>
              <input
                type="date"
                className="form-control"
                id="endDate"
                value={endDate}
                onChange={handleEndDateChange}
              />
            </div>
            <div className="col-2 mx-3 mt-4">
              <button type="submit" className="btn btn-primary" disabled={isDisabled}>
                Submit
              </button>
            </div>
          </div> */}
        <div className="reportingDate mb-3 mt-3 row">

          {/* Date Range Dropdown */}
          <div className="col-4 mx-3">
            {/* <label htmlFor="dateRange">Date Range</label> */}
            <select id="dateRange" className="form-control" value={dateRange} onChange={handleDateRangeChange}>
              {/* <option value="today">Today</option> */}
              <option value="yesterday">Yesterday</option>
              <option value="last7">Last 7 Days</option>
              <option value="last15">Last 15 Days</option>
              <option value="last30">Last 30 Days</option>
              <option value="thisMonth">This Month</option>
              <option value="lastMonth">Last Month</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>

          {/* Show dates ONLY for Custom Range */}
          {dateRange === "custom" && (
            <>
              {/* Start Date */}
              <div className="col-3">
                <label htmlFor="startDate">Start Date</label>
                <input type="date" className="form-control" id="startDate" value={startDate} onChange={handleStartDateChange} />
              </div>

              {/* End Date */}
              <div className="col-3">
                <label htmlFor="endDate">End Date</label>
                <input type="date" className="form-control" id="endDate" value={endDate} onChange={handleEndDateChange} />
              </div>
            </>
          )}

          {/* Submit */}
          <div className="col-4">
            <button type="submit" className="publisher-submit-btn" disabled={isDisabled}>
              Submit
            </button>
          </div>

        </div>
        {errorMessage && (
          <p style={{ color: "red" }} className="mx-4 my-0">
            {errorMessage}
          </p>
        )}
        </form>
     </div>
     <div className="mb-3 mx-3 d-flex justify-content-end">
       <button className="btn btn-success downlodeBtn" onClick={downloadReport}>
         Download <img src={reportIcon} alt="Download" />
       </button>
     </div>
     <div className="report-table-wrapper">
       <div className="table-responsive adminReport">
         <table className="table table-striped table-hover table-bordered report-table">
           <thead>
             <tr>
               <th>SN</th>
               <th>Date</th>
               <th>Domain</th>
               <th>Account Name</th>
               <th>Ad Id</th>
               <th>Clicks</th>
               <th>Impressions</th>
               <th>CTR</th>
               <th>Fill Rate</th>
               {/* <th>m_ad_display_name </th> */}
               <th>Ad Display Name </th>
               <th>Ad Unit Name</th>
               <th>Pub Revenue</th>
               <th>Pub eCPM</th>
               <th>Revenue</th>
               <th>eCPM</th>
               <th>Viewable Impression</th>
               <th>Requests</th>
               <th>Match Requests</th>
               <th>Coverage</th>
               <th>Original Impressions</th>
               <th>Original PubRev</th>
               <th>Original Requests</th>
               <th>Visible on Report</th>
               <th>Multi Tag Visible on Report</th>
             </tr>
           </thead>
           <tbody>
             {reportData.length > 0 ? (
               reportData.map((entry, index) => (
                 <tr key={index}>
                   <td>{index + 1}</td>
                   <td>{entry.date}</td>
                   <td>{entry.domain}</td>
                   <td>{entry.account_name}</td>
                   <td>{entry.ad_id}</td>
                   <td>{entry.clicks}</td>
                   <td>{entry.impressions}</td>
                   <td>{entry.ctr === null ? "0" : entry.ctr}</td>
                   <td>{entry.fill_rate}</td>
                   <td>{entry.m_ad_display_name}</td>
                   <td>{entry.m_ad_unit_name}</td>
                   <td>{entry.pubRev}</td>
                   <td>{entry.pub_eCPM === null ? "0" : entry.pub_eCPM}</td>
                   <td>{entry.revenue}</td>
                   <td>{entry.ecpm === null ? "0" : entry.ecpm}</td>
                   <td>{entry.viewable_impression}</td>
                   <td>{entry.requests}</td>
                   <td>{entry.match_requests}</td>
                   <td>{entry.coverage}</td>
                   <td>{entry.orig_impressions}</td>
                   <td>{entry.orig_pubRev}</td>
                   <td>{entry.orig_requests}</td>
                   <td>{entry?.p_isvisible === 1 ? "No" : "Yes"}</td>
                   <td>{entry?.m_isvisible === 1 ? "No" : "Yes"}</td>
                 </tr>
               ))
             ) : (
               <tr>
                 <td colSpan={24} className="text-center">No data available</td>
               </tr>
             )}
           </tbody>
           {reportData.length > 0 && (
             <tfoot>
               <tr className="report-total-row">
                 <td colSpan={5} className="report-total-label">
                   Page Total ({reportData.length} records)
                 </td>
                 <td>{formatCount(pageTotals.clicks)}</td>
                 <td>{formatCount(pageTotals.impressions)}</td>
                 <td>{formatPercent(pageTotals.clicks, pageTotals.impressions)}</td>
                 <td>—</td> {/* Fill Rate needs its confirmed aggregate formula */}
                 <td>—</td> {/* Ad Display Name */}
                 <td>—</td> {/* Ad Unit Name */}
                 <td>{formatAmount(pageTotals.pubRev)}</td>
                 <td>{formatEcpm(pageTotals.pubRev, pageTotals.impressions)}</td>
                 <td>{formatAmount(pageTotals.revenue)}</td>
                 <td>{formatEcpm(pageTotals.revenue, pageTotals.impressions)}</td>
                 <td>{formatCount(pageTotals.viewable_impression)}</td>
                 <td>{formatCount(pageTotals.requests)}</td>
                 <td>{formatCount(pageTotals.match_requests)}</td>
                 <td>{formatPercent(pageTotals.match_requests, pageTotals.requests)}</td>
                 <td>{formatCount(pageTotals.orig_impressions)}</td>
                 <td>{formatAmount(pageTotals.orig_pubRev)}</td>
                 <td>{formatCount(pageTotals.orig_requests)}</td>
                 <td>—</td> {/* Visible on Report */}
                 <td>—</td> {/* Multi Tag Visible on Report */}
               </tr>
             </tfoot>
           )}
         </table>
       </div>
     </div>
      {
          totalEntries > 50 ?       
          <div className="pagination d-flex justify-content-center mt-3">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <button
              key={number}
              onClick={() => setCurrentPage(number)}
              className={`btn mx-1 ${currentPage === number ? "btn-primary" : "btn-outline-primary"}`}
            >
              {number}
            </button>
          ))}
        </div> : null
        }
    </section>

 );
};

export default AdminAllReports;